<template>
  <div class="market-navigation-drawer">
    <v-card class="mx-auto" height="300" width="250" v-show="active">
      <v-navigation-drawer absolute width="100%" height="256" v-model="active">
        <v-list>
          <v-list-item
            v-for="(market, i) in marketsTransformedList"
            :key="i"
            link
          >
            <v-list-item-content>
              <v-list-item-title
                @click="
                  doAction({ marketName: market.name, marketId: market.id })
                "
              >
                {{ market.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import filter from 'lodash/filter'

export default {
  name: 'MarketNavigationDrawer',
  props: {
    marketsList: {},
    sportCategoryTournamentInfo: {},
  },
  data: () => ({
    marketSelected: null,
    marketsTransformedList: [],
    active: false,
    initialized: false,
  }),
  computed: {
    ...mapGetters({
      getMarketsGroupsIdActive: 'odds/getMarketsGroupsIdActive',
      getConfiguredGroupsMarkets: 'odds/getConfiguredGroupsMarkets',
    }),
    getGroupMarketActiveForTournament() {
      const vm = this

      let groupMarketActive = null

      const marketsGroupActives = this.getMarketsGroupsIdActive

      const marketGroupSelectedForThisTournament = filter(
        marketsGroupActives,
        function (groupMarket) {
          return (
            groupMarket.tournamentId ==
            vm.sportCategoryTournamentInfo.tournament.id
          )
        }
      )

      if (
        marketGroupSelectedForThisTournament != null &&
        marketGroupSelectedForThisTournament.length > 0
      ) {
        groupMarketActive = marketGroupSelectedForThisTournament[0]
      }

      return groupMarketActive != null
        ? groupMarketActive.groupNameSelected
        : 'ERROR'
    },
  },
  methods: {
    ...mapActions({}),

    doAction(market) {
      this.active = false

      const eventObj = {
        object: this.sportCategoryTournamentInfo,
        market: market.marketId,
        marketId: market.marketId,
        marketName: market.marketName,
      }
      this.$root.$emit('getOddsForMarket', eventObj)
    },
    initializeMarketSelector(fromMount = false) {
      // console.log('initializeMarketSelector')

      const vm = this

      this.marketsTransformedList = []

      for (const market of this.marketsList) {
        //console.log(market)
        const marketMini = {
          id: market.id,
          unique_id: market.unique_id,
          sort: market.sort,
          sortMobile: market.sortMobile,
          name: market.detail[0].text,
        }

        this.marketsTransformedList.push(marketMini)
      }
      if (this.marketsTransformedList.length > 0) {
        this.marketSelected = this.marketsTransformedList[0]
      }

      this.active = false

      if (this.initialized === true) {
        setTimeout(() => {
          vm.active = true // fix me this is a working around problem
        }, 200)
      }

      this.initialized = true
    },
  },
  watch: {
    marketsList(newList, oldList) {
      // console.log('watch marketsList inside market select component')
      // console.log('newList', newList)
      // console.log('oldList', oldList)
      if (newList != null && newList.length > 0) {
        this.initializeMarketSelector()
      }
    },
  },
  mounted() {
    // console.log('[DEBUG] mounted the component MarketnavigationDrawer')

    const vm = this

    // this.initializeMarketSelector();

    this.$root.$on('openMarketNavigationDrawer', () => {
      vm.active = !vm.active
    })
  },
  beforeDestroy() {
    this.$root.$off('openMarketNavigationDrawer', () => {
      // console.log('destroyed')
    })
  },
}
</script>

<style scoped>
.bet-console-prefix .v-list-item__title {
  align-self: center;
  font-size: 12px !important;
  font-stretch: normal;
  letter-spacing: 0.05em;
  font-weight: 500;
  color: #121212 !important;
}

.bet-console-prefix .v-list-item__content {
  padding: 0px !important;
}

.bet-console-prefix .v-list-item {
  min-height: 31px !important;
  padding-right: 8px !important;
  padding-left: 8px !important;
}

div.v-overlay.v-overlay--active.theme--dark > div.v-overlay__scrim {
  display: none !important;
}

.bet-console-prefix .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  box-shadow: none !important;
  background-color: transparent !important;
}

div.v-overlay.v-overlay--active.theme--dark > div.v-overlay__scrim {
  opacity: 0 !important;
  display: none !important;
}

.bet-console-prefix .v-navigation-drawer .v-list:not(.v-select-list) {
  background: inherit;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.bet-console-prefix
  .theme--dark.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  /* color: #000 !important; */
  /* border-bottom: 1px solid black; */
  border-bottom: 1px solid #121212;
}

.v-navigation-drawer {
  background: #fff !important;
}
</style>
